module.exports = __webpack_public_path__ + "img/disrupteev-sem-slogan.4198fdf0.svg";